const $ = jQuery.noConflict();

const slider = () => {
	// Cache DOM
	const sliderWrapper = $('.slider-section__slides-wrapper');

	// Bind Events
	if (sliderWrapper.length) {
		sliderWrapper.slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			mobileFirst: true,
			centerMode: true,
			centerPadding: 0,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
					},
				},
			],
		});
	}
};

export default slider;
